import { useState } from "react";
import { Button } from "../../../../components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from "../../../../components/ui/dialog";
import { AppInput } from "../../../../components/appComponents";
import { TournamentMatchResultEnum } from "../../../../constants/appConstant";
import { useEffect } from "react";
import Common from "../../../../helper/common";
import Utility from "../../../../helper/utilityHelper";

const MatchResultRefactor = ({ isOpen, open, setOpen, onClose, match, tournament, isUmpire = false }) => {
    const [team1Sets, setTeam1Sets] = useState(["", "", ""]);
    const [team2Sets, setTeam2Sets] = useState(["", "", ""]);
    const [winner, setWinner] = useState(null);
    const [matchResults, setMatchResults] = useState([]);

    useEffect(() => {
        if (match) {
            if (match.results) {
                var results = JSON.parse(match.results);
                setMatchResults(results);
                console.log(
                    results
                        .filter((set) => set.side === "A")
                        .map((item) => item.points.toString())
                        .slice(0, 3)
                );
                setTeam1Sets(
                    results
                        .filter((set) => set.side === "A")
                        .map((item) => item.points.toString())
                        .slice(0, 3)
                );
                setTeam2Sets(
                    results
                        .filter((set) => set.side === "B")
                        .map((item) => item.points.toString())
                        .slice(0, 3)
                );
                setWinner(match.matchResult);
            } else {
                setTeam1Sets(["", "", ""]);
                setTeam2Sets(["", "", ""]);
                console.log("tournament", tournament);
                console.log("match", match);
                var players1 = tournament["teams"].find(
                    (e) => e["id"] == match.teamAId
                )["players"];
                var players2 = tournament["teams"].find(
                    (e) => e["id"] == match.teamBId
                )["players"];
                console.log("players1", players1);
                console.log("players2", players2);
                var sets = [1, 2, 3];
                var results = [];

                players1.forEach((player) => {
                    sets.forEach((set) => {
                        results.push({
                            bookingResultTmpId: 0,
                            playerId: player.id,
                            side: "A",
                            round: set,
                            points: "",
                            gameType: 1,
                            resultType: 1,
                        });
                    });
                });

                players2.forEach((player) => {
                    sets.forEach((set) => {
                        results.push({
                            bookingResultTmpId: 0,
                            playerId: player.id,
                            side: "B",
                            round: set,
                            points: "",
                            gameType: 1,
                            resultType: 1,
                        });
                    });
                });

                setMatchResults(results);

                console.log("result", results);
            }
        }
    }, [match]);

    useEffect(() => {
        calculateWinner();
    }, [team1Sets, team2Sets]);

    const handleSetChange = (team, setIndex, value) => {
        //const numValue = value === "" ? "" : parseInt(value, 10);
        const numValue = value === "" ? "" : value;

        if (team === 1) {
            const newSets = [...team1Sets];
            newSets[setIndex] = numValue;
            setTeam1Sets(newSets);
        } else {
            const newSets = [...team2Sets];
            newSets[setIndex] = numValue;
            setTeam2Sets(newSets);
        }
    };

    const calculateWinner = () => {
        debugger
        let team1Wins = 0;
        let team2Wins = 0;

        for (let i = 0; i < 3; i++) {
            if (team1Sets[i] !== "" && team2Sets[i] !== "") {
                if (parseInt(team1Sets[i]) > parseInt(team2Sets[i])) {
                    team1Wins++;
                } else if (parseInt(team1Sets[i]) < parseInt(team2Sets[i])) {
                    team2Wins++;
                }
            }

        }

        if (team1Wins > team2Wins) {
            setWinner(TournamentMatchResultEnum.Team_A_Won);
        } else if (team2Wins > team1Wins) {
            setWinner(TournamentMatchResultEnum.Team_B_Won);
        }
        else if (team2Wins == 0 && team1Wins == 0) {
            setWinner(TournamentMatchResultEnum.No_Result);
        }
        else {
            setWinner(null);
        }
    };

    const handleSave = async () => {
        if (!winner) {
            return;
        }
        // Update points in existing results based on the new set scores
        const updatedResults = matchResults?.map((result) => {
            // Create a copy of the result to avoid mutating the original
            const updatedResult = { ...result };

            // Calculate total points for each side based on set scores
            if (result.side === "A") {
                // For Team A, sum up their set scores
                // Use the points directly from the set instead of summing
                const setIndex = result.round - 1; // Assuming set is 1-indexed in the result
                updatedResult.points =
                    team1Sets[setIndex] === ""
                        ? 0
                        : parseInt(team1Sets[setIndex].toString(), 10);
            } else if (result.side === "B") {
                // For Team B, sum up their set scores
                const setIndex = result.round - 1; // Assuming set is 1-indexed in the result
                updatedResult.points =
                    team2Sets[setIndex] === ""
                        ? 0
                        : parseInt(team2Sets[setIndex].toString(), 10);
            }

            return updatedResult;
        });
        console.log(updatedResults);

        var data = {
            results: JSON.stringify(updatedResults),
            tournamentScheduleId: match?.id,
            isReUploadResult: match.results ? true : false,
            matchResult: winner,
        };

        const endpoint = isUmpire 
            ? `/UmpireTournament/UpdateUmpireTournamentMatchResult`
            : `UpdateTournamentMatchResult`;

        await Common.ApiService.getInstance().request(
            endpoint,
            data,
            "POST"
        );

        if (onClose) {
            onClose(true);
        } else if (setOpen) {
            setOpen(false);
        }

        // const result = {
        //   matchId: match?.id,
        //   team1Sets,
        //   team2Sets,
        //   matchResult: winner,
        // };

        // onSave(result);
        // onClose();
    };

    const dialogOpen = isOpen !== undefined ? isOpen : open;
    const handleClose = onClose || (() => setOpen && setOpen(false));

    return (
        <Dialog open={dialogOpen} onOpenChange={handleClose}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle className="text-center text-xl font-bold">
                        Match Result
                    </DialogTitle>
                </DialogHeader>

                <div className="py-4">
                    <div className="flex justify-between items-center mb-4">
                        <div className="font-semibold text-lg w-1/2">Teams</div>
                        <div className="flex justify-between w-1/2">
                            <div className="text-center font-semibold">Set 1</div>
                            <div className="text-center font-semibold">Set 2</div>
                            <div className="text-center font-semibold">Set 3</div>
                        </div>
                    </div>

                    {/* Team 1 */}
                    <div className="flex justify-between items-center mb-4">
                        <div className="w-1/2 pr-4">
                            <div className="font-medium">{match?.team1}</div>
                        </div>
                        <div className="flex justify-between w-1/2 space-x-2">
                            {[0, 1, 2].map((index) => (
                                <AppInput
                                    key={`team1-set-${index}`}
                                    type="number"
                                    min="0"
                                    className="w-16"
                                    value={team1Sets[index]}
                                    onChange={(value) => handleSetChange(1, index, value)}
                                />
                            ))}
                        </div>
                    </div>

                    {/* Team 2 */}
                    <div className="flex justify-between items-center">
                        <div className="w-1/2 pr-4">
                            <div className="font-medium">{match?.team2}</div>
                        </div>
                        <div className="flex justify-between w-1/2 space-x-2">
                            {[0, 1, 2].map((index) => (
                                <AppInput
                                    key={`team2-set-${index}`}
                                    type="number"
                                    min="0"
                                    className="w-16"
                                    value={team2Sets[index]}
                                    onChange={(value) => handleSetChange(2, index, value)}
                                />
                            ))}
                        </div>
                    </div>

                    {winner && winner != TournamentMatchResultEnum.No_Result && (
                        <div className="mt-4 text-center font-semibold text-green-600">
                            Winner:{" "}
                            {winner === TournamentMatchResultEnum.Team_A_Won
                                ? match?.team1 : winner === TournamentMatchResultEnum.Team_B_Won
                                    ? match?.team2
                                    : " "}
                        </div>
                    )}

                    {winner === TournamentMatchResultEnum.No_Result &&
                        (team1Sets.some(set => set !== "") || team2Sets.some(set => set !== "")) && (
                            <div className="mt-4 text-center font-semibold text-green-600">
                                No Result
                            </div>
                        )}

                </div>

                <DialogFooter>
                    <Button variant="outline" onClick={onClose} className="mr-2">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSave}
                        disabled={
                            !winner ||
                            !team1Sets.some(set => set !== "") ||
                            !team2Sets.some(set => set !== "")
                        }
                        className={
                            !winner ||
                                !team1Sets.some(set => set !== "") ||
                                !team2Sets.some(set => set !== "")
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                        }
                    >
                        Save Result
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default MatchResultRefactor;
